import React from 'react';
import PropTypes from 'prop-types';
import Player from '../Player';


const ActiveItem = ({ name, slug, longDescription, metadata: { sourceUrl, sourceId }, duration, width, height, onPlayerInit, onPlayerEnd }) => {
  const aspectRatio = width && height ? `${width}:${height}` : undefined;
  return (
    <div className="mb-3">
      <div className="mb-4">
        <Player
          key={slug}
          video={sourceUrl || sourceId}
          slug={slug}
          aspectRatio={aspectRatio}
          onInit={onPlayerInit}
          onEnd={onPlayerEnd}
        />
      </div>
      <div>
        <h4 className="heading-display">{name}</h4>
        <div className="body-copy" dangerouslySetInnerHTML={{ __html: longDescription }} />
      </div>
    </div>
  );
};

ActiveItem.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onPlayerInit: PropTypes.func,
  onPlayerEnd: PropTypes.func,
};

ActiveItem.defaultProps = {
  onPlayerInit: () => {},
  onPlayerEnd: () => {},
};

export default ActiveItem;



// WEBPACK FOOTER //
// ./src/components/Playlist/ActiveItem.js